import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: any) {

    const start = this.el.nativeElement.selectionStart;
    const end = this.el.nativeElement.selectionEnd;
    
    // Transforma o valor em maiúsculo
    this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
    
    // Mantém a posição do cursor (evita que ele pule para o fim do input)
    this.el.nativeElement.setSelectionRange(start, end);
    
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directive/uppercase.directive.ts